const DAY_MS = 86_400_000;
const relativeFormat = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

export function relativeDays(timeMs: number): string {
  return relativeFormat.format(
    Math.round((timeMs - Date.now()) / DAY_MS),
    'day'
  );
}

export function isWithinDays(timeMs: number, days: number): boolean {
  return timeMs - Date.now() <= days * DAY_MS;
}

export function shortDate(timeMs: number): string {
  return new Date(timeMs).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  });
}

export function addDays(timeMs: number, days: number): string {
  return new Date(timeMs + days * DAY_MS).toISOString().split('T')[0];
}

export function endOfDayMs(isoDate: string): number {
  return new Date(`${isoDate}T23:59:59Z`).getTime();
}

export const PLAN_OPTIONS = [
  { value: 'plus_monthly', label: 'Plus' },
  { value: 'power_monthly', label: 'Power' },
  { value: 'pro_monthly', label: 'Pro' },
  { value: 'pro2_monthly', label: 'Pro2' },
];

export function planLabel(plan: string): string {
  return PLAN_OPTIONS.find((option) => option.value === plan)?.label ?? plan;
}

export const TIER_OPTIONS = ['plus', 'power', 'pro', 'pro2'] as const;

export function parseEmails(text: string): string[] {
  return text
    .split(/[\s,;]+/)
    .map((email) => email.trim())
    .filter(Boolean);
}

export function people(count: number): string {
  return count === 1 ? '1 person' : `${count} people`;
}
